import React from 'react'

// icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'

// routes
import { withRouter } from 'react-router-dom'

// Sweet alert
import Swal from 'sweetalert2'

// services
import { deleteByIdDatoFiscal } from '../../Services/datoFiscalService'

const ItemDatoFiscal = ({ datoFiscal, history, setIsLoad }) => {
    const eliminarDatoFiscal = (id) => {
        Swal.fire({
            title: 'Estas seguro de eliminar?',
            text: 'Se eliminara un dato fiscal',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, Eliminar!',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.value) {
                // consulta a la api para eliminar
                deleteByIdDatoFiscal(id)
                    .then((res) => {
                        Swal.fire(
                            'Eliminado!',
                            'El dato fiscal fue eliminado.',
                            'success'
                        )
                        setIsLoad(true)
                    })
                    .catch((error) => {
                        Swal.fire({
                            type: 'error',
                            title: 'Error',
                            text: 'Hubo un error vuelve a intentar!',
                        })
                        console.log(error.response)
                    })
            }
        })
    }

    return (
        <tr>
            <th scope="row">{datoFiscal.id}</th>
            <td>{datoFiscal.razonSocial}</td>
            <td>{datoFiscal.domicilioFiscal}</td>
            <td>{datoFiscal.condicionFiscal.nombre}</td>
            <td>{datoFiscal.cuitCuil}</td>
            <td>{datoFiscal.apiKey}</td>
            <td>
                <button
                    className="btn text-danger"
                    onClick={() => {
                        history.push(`edit-dato-fiscal/${datoFiscal.id}`, {
                            datoFiscal: datoFiscal,
                        })
                    }}
                >
                    <FontAwesomeIcon icon={faEdit} /> Editar
                </button>
                <button
                    className="btn text-primary"
                    onClick={() => eliminarDatoFiscal(datoFiscal.id)}
                >
                    <FontAwesomeIcon icon={faTrash} /> Eliminar
                </button>
            </td>
        </tr>
    )
}

export default withRouter(ItemDatoFiscal)
